import React from 'react';
import { View, Pressable, StyleSheet } from 'react-native';
import { Tabs } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import '../../src/i18n';
import { colors, fonts } from '../../src/ui/theme';
import { TwoNeedlesIcon } from '../../src/ui/shared/TwoNeedlesIcon';

/** Botão elevado (estilo FAB) da aba central "Projetos" — pedido explícito
 * da usuária: é a aba mais usada, precisa se destacar das outras duas. As
 * outras abas usam o `tabBarIcon` padrão; esta sobrescreve `tabBarButton`
 * inteiro para poder saltar acima da barra (`marginTop` negativo). */
function ProjectsTabButton({ accessibilityState, onPress }: any) {
  const focused = accessibilityState?.selected;
  return (
    <View style={styles.fabWrapper}>
      <Pressable style={[styles.fabButton, focused && styles.fabButtonFocused]} onPress={onPress}>
        <TwoNeedlesIcon size={28} color={colors.onSage} />
      </Pressable>
    </View>
  );
}

export default function TabsLayout() {
  const { t } = useTranslation();

  return (
    <Tabs
      screenOptions={{
        tabBarActiveTintColor: colors.sageDeep,
        tabBarInactiveTintColor: colors.thread,
        tabBarStyle: { backgroundColor: colors.sand, borderTopColor: colors.line, height: 64, paddingBottom: 8 },
        tabBarLabelStyle: { fontFamily: fonts.bodyMedium, fontSize: 12 },
        headerStyle: { backgroundColor: colors.sand },
        headerTitleStyle: { fontFamily: fonts.display, color: colors.ink },
        headerTintColor: colors.sageDeep,
      }}
    >
      <Tabs.Screen
        name="catalogo"
        options={{
          title: t('tabs.catalog.title'),
          tabBarIcon: ({ color, size }) => <MaterialCommunityIcons name="tag-outline" size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="index"
        options={{
          title: t('tabs.projects.title'),
          tabBarLabel: () => null,
          tabBarButton: (props) => <ProjectsTabButton {...props} />,
        }}
      />
      <Tabs.Screen
        name="perfil"
        options={{
          title: t('tabs.profile.title'),
          tabBarIcon: ({ color, size }) => <MaterialCommunityIcons name="account-outline" size={size} color={color} />,
        }}
      />

      {/* Rotas alcançadas só via push (detalhe de projeto, preço) — ficam
          dentro do navegador de abas para a navbar continuar visível nelas
          (pedido explícito da usuária), mas não aparecem como botão próprio
          na barra (`href: null`) nem duplicam cabeçalho (`headerShown:
          false`, essas telas já desenham o próprio "Voltar"). */}
      <Tabs.Screen name="projeto/[id]" options={{ href: null, headerShown: false }} />
      <Tabs.Screen name="preco/[projectId]" options={{ href: null, headerShown: false }} />
    </Tabs>
  );
}

const styles = StyleSheet.create({
  fabWrapper: { flex: 1, alignItems: 'center', justifyContent: 'flex-end' },
  fabButton: {
    width: 56,
    height: 56,
    borderRadius: 28,
    marginTop: -20,
    backgroundColor: colors.sageDeep,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 3,
    borderColor: colors.sand,
  },
  fabButtonFocused: { backgroundColor: colors.sage },
});
